import { ProductTileContext } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/common";
import { ProductClickForSearchPageParameters } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import { useProductTileClickImpressions } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressions";
import React from "react";

/**
 * Use this function to get customized on click tracking events, like heart click, quickadd click and ect.
 * For tile click and page redirection, use `useOnProductClickBase`.
 * @param params A list of params you wish to send with tile click events
 * @returns
 */
export const useGetProductTileClickImpressions = (
  params: ProductClickForSearchPageParameters
) => {
  const { recordAdImpression, brand, brandToken } =
    React.useContext(ProductTileContext);

  return useProductTileClickImpressions(
    params,
    brandToken ?? brand?.token,
    recordAdImpression
  );
};
